export default {
  getLogStock: (state) => state.products,
  getWarehouses: (state) => state.warehouses,
  getWarehousesMap(state) {
    let warehouses = {};

    if (state.warehouses)
      state.warehouses.forEach((w) => {
        warehouses[w.id] = { ...w };
      });

    return warehouses;
  },
  getWarehousesStockLogs: (state) => state.stockLogs,
  getWarehousesStockLogTypes: (state) => state.stockLogTypes,
};
// export default {
//   getZone: (state) => state.zone,
//   getDefaultZones: (state) => state.defaultZones,
//   getCountryPhoneFormat: (state) => state.countryPhoneFormat,
//   getCountries: (state) => state.countries,
// };
